import {ChangeDetectionStrategy, Component, input, output, ViewEncapsulation} from '@angular/core';
import {SurveyMetricDimension} from '../../../../../../types/SurveyMetricDimension';

@Component({
  selector: 'app-cpru-survey-dimension',
  templateUrl: './cpru-survey-dimension.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpruSurveyDimensionComponent {
  public dimension = input<SurveyMetricDimension>(null);
  public opened = input<boolean>(false);
  public openPanel = output<boolean>();

  public openQuestionsPanel(): void {
    this.openPanel.emit(true);
  }
}
